import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  idFrom:"",
  idTo:"",
  defaultStoreIdFrom:"",
  defaultStoreIdTo:"",
  useraccountIdFrom:"",
  useraccountIdTo:"",
  numberShippingFrom:"",
  numberShippingTo:"",
  dateShippingFrom:null,
  dateShippingTo:null,
  ori_tras_store_idFrom:"",
  ori_tras_store_idTo:"",
  dest_tras_store_idFrom:"",
  dest_tras_store_idTo:"",
  rel_trans_store_idFrom:"",
  rel_trans_store_idTo:"",
  vehicleFrom:"",
  vehicleTo:""
};

const filtersShippingsSlice = createSlice({
  name: 'filtersShippings',
  initialState,
  reducers: {
    setFilters(state, action) {
      return { ...state, ...action.payload };
    },
    resetFilters() {
      return initialState;
    },
  },
});

export const { setFilters, resetFilters } = filtersShippingsSlice.actions;
export default filtersShippingsSlice.reducer;
